@if (!environment.production || authService.isAdmin()) {
    <p-card class="mb-4">
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
                <p-button label="Réessayer envoi EBP" icon="pi pi-undo" iconPos="right" (click)="onRetry()" text />
            </div>
        </div>
    </p-card>
}

<p-card>
    <p-table
        #dt
        [value]="ebpStocks"
        dataKey="stock_id"
        [lazy]="true"
        [paginator]="true"
        [totalRecords]="resultsLength"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first} - {last} sur {totalRecords}"
        [rows]="pageSize"
        [rowsPerPageOptions]="[10, 20, 50]"
        sortField="ecart_pourcentage"
        [sortOrder]="-1"
        [(selection)]="selectedEbpStock"
        [columns]="selectedColumns"
        [loading]="isLoadingResults"
        [scrollable]="true"
        scrollHeight="634px"
        (onLazyLoad)="onLazyLoad($event)"
        (onStateRestore)="onStateRestore($event)"
        stateKey="_ssk"
        stateStorage="local"
        [defaultSortOrder]="-1"
    >
        <ng-template #header let-columns>
            <tr>
                @for (col of columns; track $index) {
                    <th>{{ col.header }}</th>
                }
            </tr>
        </ng-template>

        <ng-template #body let-ebayStockPrice let-columns="columns">
            <tr>
                @for (col of columns; track $index) {
                    @switch (col.field) {
                        @case ('produit_id') {
                            <td>
                                <a [routerLink]="['/products', ebayStockPrice.produit_id]" [queryParams]="{stock_id: ebayStockPrice.stock_id}" class="flex flex-col justify-center items-center">
                                    <img [src]="apiUrl + ebayStockPrice.photo_couverture" alt="{{ebayStockPrice.reference}}" width="80" height="80" class="h-20 w-20 shadow-lg object-cover rounded-md" />
                                    <p-tag severity="contrast" [value]="'#' + ebayStockPrice.produit_id" class="-mt-3 relative z-0 !text-base" />
                                </a>
                            </td>
                        }
                        @case ('etat') {
                            <td><p-tag [severity]="utilityService.getStateSeverity(ebayStockPrice.etat)" [value]="utilityService.getStateLabel(ebayStockPrice.etat)" class="mt-2" /></td>
                        }
                        @case ('date_update') {
                            <td>{{ ebayStockPrice[col.field] | date:'shortDate' }}</td>
                        }
                        @default {
                            <td>{{ ebayStockPrice[col.field] }}</td>
                        }
                    }
                }
            </tr>
        </ng-template>
    </p-table>
</p-card>
